import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ParametrosNuevaSolicitudCpeViewModel, SolicitudCpeViewModel } from './cpe.types';

@Injectable()
export class SolicitudCpeService {
    private paramsKey = 'cpeParams';
    public currentParamNuevaSolicitudCpe = new ParametrosNuevaSolicitudCpeViewModel();
    public currentIdSolicitudCpe: number;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    // Persist params into localStorage or removes it if a NULL argument is given
    setParamsSolicitudCpe(params: ParametrosNuevaSolicitudCpeViewModel | null): boolean {
        if (params) {
            localStorage.setItem(this.paramsKey, JSON.stringify(params));
        } else {
            localStorage.removeItem(this.paramsKey);
        }
        return true;
    }

    // Retrieves the params JSON object (or NULL if none)
    getParamsSolicitudCpe(): ParametrosNuevaSolicitudCpeViewModel | null {
        let params: ParametrosNuevaSolicitudCpeViewModel = new ParametrosNuevaSolicitudCpeViewModel();
        let paramsJSON: ParametrosNuevaSolicitudCpeViewModel;

        let i = localStorage.getItem(this.paramsKey);
        if (i) {
            paramsJSON = JSON.parse(i);

            params.IdCa = paramsJSON.IdCa;

            return params;
        } else {
            return null;
        }
    }

    getSolicitudCpe(id: number): Observable<SolicitudCpeViewModel> {
        return this.http.get<SolicitudCpeViewModel>(this.baseUrl + 'api/exportacion/cpes/solicitudCpe/' + id).pipe();
    }

    getEnvioSolicitud(id: number): Observable<SolicitudCpeViewModel> {
        return this.http.get<SolicitudCpeViewModel>(this.baseUrl + 'api/exportacion/cpes/solicitudCpe/getenviosolicitudbyid/' + id).pipe();
    }

    /*--------*/

    createSolicitud(solicitudCpe: SolicitudCpeViewModel): Observable<any> {
        return this.http.post<SolicitudCpeViewModel>(this.baseUrl + 'api/exportacion/cpes/solicitudCpe', solicitudCpe).pipe();
    }

    editSolicitud(solicitudCpe: SolicitudCpeViewModel): Observable<any> {
        return this.http.put<SolicitudCpeViewModel>(this.baseUrl + 'api/exportacion/cpes/solicitudCpe', solicitudCpe).pipe();
    }
}
